<div [class]="containerClasses()" role="region" aria-label="Notifications">
      @for (toast of toastService.toasts(); track toast.id) {
        <ui-toast
          [toast]="toast"
          (dismiss)="toastService.dismiss($event)"
        ></ui-toast>
      }
    </div>
